const aaroh = (name) => `/images/aaroh/archive/${name}-1800.webp`;

export const AAROH_IMAGES = {
  room: aaroh("aaroh-room"),
  roomWide: aaroh("aaroh-room-wide"),
  buildSession: aaroh("aaroh-build-session"),
  studentSpeaker: aaroh("aaroh-student-speaker"),
  studentPresentation: aaroh("aaroh-student-presentation"),
  studentDiscussion: aaroh("aaroh-student-discussion"),
  studentTeam: aaroh("aaroh-student-team"),
  studentPortrait: aaroh("aaroh-student-portrait"),
  recognition: aaroh("aaroh-recognition"),
  collaboration: aaroh("aaroh-collaboration"),
};

export const AAROH_IMAGE_DIMENSIONS = {
  "aaroh-room": [1800, 1012],
  "aaroh-room-wide": [1800, 1012],
  "aaroh-build-session": [1800, 1200],
  "aaroh-student-speaker": [1800, 1200],
  "aaroh-student-presentation": [1800, 1200],
  "aaroh-student-discussion": [1800, 1200],
  "aaroh-student-team": [1800, 1012],
  "aaroh-student-portrait": [1800, 1200],
  "aaroh-recognition": [1800, 1012],
  "aaroh-collaboration": [1800, 1012],
};
